import React, { useState, useContext } from "react";
import { Banner, toast } from "@jsq/ds/core";
import { useManuallyCompleteSubscriptionStaffReviewMutation } from "common/types/gqlSchemaTypes";
import styles from "./styles.scss";
import { SubscriptionStaffReviewContextState } from "../context";

export function ManualCompleteStaffReviewBanner(): React.ReactElement | null {
  const [manualCompletionLoading, setManualCompletionLoading] = useState(false);
  const [manuallyCompleteStaffReview] = useManuallyCompleteSubscriptionStaffReviewMutation();
  const { globalSubscriptionId, staffReviewCompleted, onStaffReviewCompleted } = useContext(
    SubscriptionStaffReviewContextState,
  );

  async function handleManualCompletion() {
    setManualCompletionLoading(true);
    const result = await manuallyCompleteStaffReview({
      variables: { subscriptionId: globalSubscriptionId },
    });
    if (
      result.data?.manuallyCompleteSubscriptionStaffReview?.__typename ===
      "MutationErrorResponse"
    ) {
      toast.error(result.data.manuallyCompleteSubscriptionStaffReview.message);
    } else if (
      result.data?.manuallyCompleteSubscriptionStaffReview?.__typename ===
      "MutationSuccessResponse"
    ) {
      onStaffReviewCompleted("Subscription staff review completed");
    }
    setManualCompletionLoading(false);
  }

  return staffReviewCompleted ? null : (
    <Banner
      data-testid="manual-complete-staff-review-banner"
      className={styles.ManualCompleteStaffReviewBanner}
      variant="primary"
      title="Reviewers removed during review"
      description="Remaining reviewers listed have approved"
      buttonProps={{
        icon: "arrow-right",
        children: "Complete",
        onClick: handleManualCompletion,
        variant: "primary",
        disabled: manualCompletionLoading,
        "data-testid": "manual-complete-staff-review-button",
      }}
    />
  );
}
